export const ArrowRightNew = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    fill="none"
    viewBox="0 0 8 14"
  >
    <path
      stroke="#0A0D14"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m1 13 6-6-6-6"
    />
  </svg>
);
